import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withParentSize } from '@visx/responsive';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { component } from 'Helpers/PropTypes';
import DetailView from './DetailView';
import ListView from './ListView';

const HEADER_HEIGHT = 40;

const styles = theme => ({
  root: {
    height: '100%',
    display: 'flex',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  listView: {
    display: 'flex',
    flexDirection: 'column',
    width: theme.dimensions.sm,
    flexShrink: 0,
  },
  listViewHeader: {
    height: HEADER_HEIGHT,
  },
  listViewList: {
    overflowY: 'scroll',
    flexGrow: 1,
  },
  detailView: {
    flexGrow: 1,
    minWidth: 0,
  },
  detailViewDetail: {},
  sideColumnWidth: {
    minWidth: theme.dimensions.sm,
  },
});

const ViewBeside = withParentSize(({
  className,
  classes,
  parentHeight,
  DetailViewComponent,
  DetailViewHeaderComponent,
  ListViewListItemComponent,
  ListViewHeaderComponent,
  ListViewFooterComponent,
  ListViewListProps,
}) => {
  const { classes: listViewListClasses, ...listViewListRest } = ListViewListProps;

  return (
    <div
      className={classNames(classes.root, className)}
      style={{ maxHeight: parentHeight }}
    >
      <div className={classes.listView}>
        <ListView
          classes={{
            header: classNames(classes.listViewHeader, listViewListClasses?.header),
            list: classNames(classes.listViewList, listViewListClasses?.list),
            footer: listViewListClasses?.footer,
          }}
          highlightSelected
          ListProps={{
            ...listViewListRest,
            style: {
              maxHeight: parentHeight - HEADER_HEIGHT,
            },
          }}
          HeaderComponent={ListViewHeaderComponent}
          FooterComponent={ListViewFooterComponent}
          ListItemComponent={ListViewListItemComponent}
        />
      </div>
      <DetailView
        showEmptyState
        classes={{
          root: classes.detailView,
          detail: classes.detailViewDetail,
        }}
        DetailComponent={DetailViewComponent}
        HeaderComponent={DetailViewHeaderComponent}
      />
    </div>
  );
});

ViewBeside.defaultProps = {
  className: '',
  ListViewListProps: {},
  ListViewFooterComponent: null,
};

ViewBeside.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  DetailViewComponent: component.isRequired,
  DetailViewHeaderComponent: component.isRequired,
  ListViewHeaderComponent: component.isRequired,
  ListViewListItemComponent: component.isRequired,
  ListViewListProps: PropTypes.object,
  ListViewFooterComponent: component,
};

export default withStyles(styles)(ViewBeside);
